import { useEffect, useState, useContext } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import NotFound from "../notfound/NotFound";
import {
  editBranchOffice,
  getAllBranchOfficesTypes,
  getBranchOfficeById,
  createSalePoint,
  deleteSalePoint,
  editSalePoint,
  getAllAcceptedPaymentMethods,
  getAllChannelsByBusinessUnits,
  getCategoriesFiltered,
  getBranchOfficeSkusById,
  processExcelTemplate,
  getHistoricalStockBranchOffice,
  getDepositsFiltered,
  addScheduleToBranchOffice,
  deleteScheduleFromBranchOffice,
  getAllRecurrencesTypes,
  getVehicles,
  getBranchOfficesByName,
  getBranchOfficesByNameFast,
} from "../../api/Services";
import { BusinessUniteContext } from "../../components/layout/Layout";

import { hasPermission, privilegesEnum } from "../../helpers/PermissionHelper";

import {
  Form,
  message,
  Select,
  Modal,
  Button,
  Input,
  Switch,
  Table,
  Space,
  Tag,
  InputNumber,
  DatePicker,
  Checkbox,
  TimePicker,
  Radio,
  Tabs,
  Skeleton,
  Empty,
} from "antd";
import {
  DeleteOutlined,
  EditOutlined,
  ExclamationCircleOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import { LiaStoreSolid } from "react-icons/lia";
import CustomBreadcrumb from "../../components/breadcrumb/Breadcrumb";
import ActionButtons from "../../components/actionbuttons/ActionButtons";

import styles from "./ViewBranchOffice.module.scss";
import ArticleStock from "../../components/articlestock/ArticleStock";
import AddArticleModal from "../../components/addarticlemodal/AddArticleModal";
import { handleDownloadTemplate } from "../../helpers/Helper";
import ImportModal from "../../components/importmodal/ImportModal";

const ViewBranchOffice = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const {
    contextValue: businessUnitSelected,
    updateContextValue: setBusinessUnitSelected,
  } = useContext(BusinessUniteContext);

  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [branchOffice, setBranchOffice] = useState<any>();
  const [belongsShoppingCenter, setBelongsShoppingCenter] = useState(
    branchOffice?.belongsShoppingCenter
  );
  const [ownInventory, setOwnInventory] = useState(branchOffice?.ownInventory);
  const [deposits, setDeposits] = useState([]);
  const [articlesSelected, setArticlesSelected] = useState<any[]>([]);
  const [categories, setCategories] = useState<any[]>([]);
  const [channels, setChannels] = useState<any[]>([]);
  const [types, setTypes] = useState<any[]>([]);
  const [isNewSalePointModalVisible, setIsNewSalePointModalVisible] =
    useState(false);
  const [isEditSalePointModalVisible, setIsEditSalePointModalVisible] =
    useState(false);
  const [editingSalePoint, setEditingSalePoint] = useState<any>(null);
  const [salePointsLoading, setSalePointsLoading] = useState(false);
  const [acceptedPaymentMethods, setAcceptedPaymentMethods] = useState<any[]>(
    []
  );
  const [isOnline, setIsOnline] = useState(false);
  const [skusActualPage, setSkusActualPage] = useState(1);
  const [totalSizeSkus, setTotalSizeSkus] = useState(0);
  const [skus, setSkus] = useState<any[]>([]);
  const [historicalStockActualPage, setHistoricalStockActualPage] = useState(1);
  const [totalSizeHistoricalStock, setTotalSizeHistoricalStock] = useState(0);
  const [historicalStocks, setHistoricalStock] = useState<any[]>([]);
  const [loadingSkus, setLoadingSkus] = useState(true);
  const [loadingHistoricalStock, setLoadingHistoricalStock] = useState(false);
  const [skuFilterValue, setSkuFilterValue] = useState<string>("");
  const [downloadingTemplate, setDownloadingTemplate] = useState(false);
  const [isImportModalVisible, setIsImportModalVisible] = useState(false);
  const [importErrors, setImportErrors] = useState<any>(null);
  const [selectedDates, setSelectedDates] = useState<[any, any] | null>(null);
  const [isAddScheduleModalVisible, setIsAddScheduleModalVisible] =
    useState(false);
  const [vehicles, setVehicles] = useState<any[]>([]);
  const [recurrenceTypes, setRecurrenceTypes] = useState<any[]>([]);
  const [allBranchOffices, setAllBranchOffices] = useState<any[]>([]);
  const [allDeposits, setAllDeposits] = useState<any[]>([]);
  const [destinationType, setDestinationType] =
    useState<string>("branchOffice");
  const [activeTab, setActiveTab] = useState("general");

  const [infoBranchOfficeForm] = Form.useForm();
  const [newSalePointForm] = Form.useForm();
  const [editSalePointForm] = Form.useForm();
  const [addScheduleForm] = Form.useForm();

  const canEdit = hasPermission(privilegesEnum.WRITE_BRANCH_OFFICES);

  const { id } = useParams();

  useEffect(() => {
    if (hasPermission(privilegesEnum.READ_BRANCH_OFFICES)) {
      handleFetchBranchOffice();
      handleFetchBranchOfficeSkus();
      handleFetchAcceptedPaymentMethods();
      handleFetchBranchOfficesTypes();
      handleFetchVehicles();
      handleFetchRecurrenceTypes();
    }
  }, []);

  useEffect(() => {
    if (hasPermission(privilegesEnum.READ_BRANCH_OFFICES)) {
      handleFetchHistoricalStock();
    }
  }, [selectedDates]);

  useEffect(() => {
    if (hasPermission(privilegesEnum.READ_BRANCH_OFFICES)) {
      handleFetchBranchOfficeSkus(1);
    }
  }, [skuFilterValue]);

  useEffect(() => {
    if (
      branchOffice &&
      !branchOffice.businessUnit
        .map((businessUnit: any) => businessUnit.id)
        .includes(businessUnitSelected) &&
      businessUnitSelected &&
      !loading
    ) {
      navigate("/admin/branchoffices");
    }
  }, [businessUnitSelected]);

  const handleFetchChannels = async (businessUnitsIds: any) => {
    const response = await getAllChannelsByBusinessUnits(businessUnitsIds);
    setChannels(response);
  };

  const handleFetchBranchOfficeSkus = async (pagination = skusActualPage) => {
    setLoadingSkus(true);
    const response = await getBranchOfficeSkusById(
      id!,
      pagination - 1,
      skuFilterValue
    );
    setLoadingSkus(false);
    setSkusActualPage(pagination);
    setTotalSizeSkus(response.totalElements);
    setSkus(response.skus);
  };

  const handleFetchHistoricalStock = async (
    pagination = historicalStockActualPage
  ) => {
    setLoadingHistoricalStock(true);
    const params: any = {};

    if (selectedDates) {
      const [startDate, endDate] = selectedDates;
      if (startDate && endDate) {
        params.startDate = startDate.format("YYYY-MM-DD");
        params.endDate = endDate.format("YYYY-MM-DD");
      }
    }
    const response = await getHistoricalStockBranchOffice(id!, pagination, {
      startDate: params.startDate,
      endDate: params.endDate,
    });
    setHistoricalStockActualPage(pagination);
    setTotalSizeHistoricalStock(response.totalElements);
    setHistoricalStock(response.stocks);
    setLoadingHistoricalStock(false);
  };
  const handleFetchBranchOffice = async () => {
    const response = await getBranchOfficeById(id!);

    setArticlesSelected(response.restrictedArticles);
    handleFetchChannels(response.businessUnit.map((bu: any) => bu.id));
    if (response.supplyDeposit?.name)
      handleSearchDeposits(response.supplyDeposit.name);

    setCategories(response.restrictedCategories ?? []);
    setBranchOffice(response);
    setBusinessUnitSelected(response.businessUnit[0]?.id);
    setBelongsShoppingCenter(response.belongsShoppingCenter);
    if (response.type === "ECOMMERCE") setIsOnline(true);
    setLoading(false);
  };

  const handleFetchBranchOfficesTypes = async () => {
    const response = await getAllBranchOfficesTypes();
    setTypes(response);
  };

  const handleFetchVehicles = async () => {
    const response = await getVehicles(1, {});
    setVehicles(response.vehicles);
  };

  const handleFetchRecurrenceTypes = async () => {
    const response = await getAllRecurrencesTypes();
    setRecurrenceTypes(response);
  };

  const handleSearchBranchOffices = async (value: string) => {
    if (value.length > 2) {
      const response = await getBranchOfficesByName(value);
      setAllBranchOffices(response.branchOffices);
    } else {
      setAllBranchOffices([]);
    }
  };

  const handleSearchBranchOfficesFast = async (value: string) => {
    console.log(
      "handleSearchBranchOfficesFast called with:",
      value,
      "length:",
      value.length
    );
    if (value.length > 2) {
      console.log("Making API call to fast search...");
      try {
        const response = await getBranchOfficesByNameFast(value);
        console.log("Fast search response:", response);
        setAllBranchOffices(response.branchOffices);
      } catch (error) {
        console.error("Error in fast search:", error);
        setAllBranchOffices([]);
      }
    } else {
      console.log("Input too short, clearing results");
      setAllBranchOffices([]);
    }
  };

  const handleSearchDepositsForSchedule = async (value: string) => {
    if (value.length > 2) {
      const response = await getDepositsFiltered(0, { name: value });
      setAllDeposits(response.deposits);
    } else {
      setAllDeposits([]);
    }
  };

  const handleOpenAddScheduleModal = () => {
    setIsAddScheduleModalVisible(true);
  };

  const handleCancelAddScheduleModal = () => {
    setIsAddScheduleModalVisible(false);
    setDestinationType("branchOffice");
    addScheduleForm.resetFields();
  };

  const handleAddSchedule = async () => {
    await addScheduleForm.validateFields().then(async (data) => {
      setLoading(true);

      const {
        code,
        description,
        recurrenceType,
        monday,
        tuesday,
        wednesday,
        thursday,
        friday,
        saturday,
        sunday,
        dayMonthly,
        dayAnually,
        startTime,
        vehicleId,
        branchOfficeIdTo,
        depositIdTo,
      } = data;

      const recurrence: {
        type: any;
        dayAnually?: any;
        dayMonthly?: any;
        monday?: boolean;
        tuesday?: boolean;
        wednesday?: boolean;
        thursday?: boolean;
        friday?: boolean;
        saturday?: boolean;
        sunday?: boolean;
        startTime?: any;
        endTime?: any;
      } = {
        type: recurrenceType,
        startTime:
          startTime && startTime[0] ? startTime[0].format("HH:mm") : null,
        endTime:
          startTime && startTime[1] ? startTime[1].format("HH:mm") : null,
      };

      if (recurrenceType === "WEEKLY") {
        recurrence.monday = monday;
        recurrence.tuesday = tuesday;
        recurrence.wednesday = wednesday;
        recurrence.thursday = thursday;
        recurrence.friday = friday;
        recurrence.saturday = saturday;
        recurrence.sunday = sunday;
      } else if (recurrenceType === "MONTHLY") {
        recurrence.dayMonthly = dayMonthly;
      } else if (recurrenceType === "ANUALLY") {
        recurrence.dayAnually = dayAnually
          ? dayAnually.format("YYYY-MM-DD")
          : null;
      }

      const response = await addScheduleToBranchOffice(parseInt(id!), {
        code,
        description,
        depositIdTo,
        branchOfficeIdTo,
        vehicleId,
        recurrence,
      });

      if (response) {
        addScheduleForm.resetFields();
        await handleFetchBranchOffice();
        handleCancelAddScheduleModal();
        message.success(t("Common-AddSuccessMessage"));
      } else message.error(t("Common-ErrorMessage"));
      setLoading(false);
    });
  };

  const showDeleteScheduleConfirm = (scheduleId: number) => {
    Modal.confirm({
      title: t("Common-DeleteScheduleConfirm"),
      icon: <ExclamationCircleOutlined />,
      content: "",
      okText: t("Common-Yes"),
      okType: "danger",
      cancelText: t("Common-No"),
      onOk() {
        handleDeleteSchedule(scheduleId);
      },
    });
  };

  const handleDeleteSchedule = async (scheduleId: number) => {
    setLoading(true);
    const deleteStatus = await deleteScheduleFromBranchOffice(
      parseInt(id!),
      scheduleId
    );
    if (!deleteStatus) message.error(t("Common-DeleteErrorMessage"));
    else message.success(t("Common-DeleteSuccessMessage"));
    await handleFetchBranchOffice();
    setLoading(false);
  };

  const getRecurrenceOptions = () => {
    const options: any[] = [];

    recurrenceTypes.forEach(function (item: any) {
      options.push(
        <Select.Option value={item.value} key={item.value}>
          {item.description_es}
        </Select.Option>
      );
    });

    return options;
  };

  const schedulesColumns = [
    {
      title: t("Common-Code"),
      dataIndex: "code",
    },
    {
      title: t("Common-Description"),
      dataIndex: "description",
    },
    {
      title: t("Common-Destiny"),
      key: "destiny",
      render: (record: any) => {
        if (record.branchOfficeTo) {
          return (
            <a href={`/admin/branchoffices/${record.branchOfficeTo.id}/view`}>
              {record.branchOfficeTo.name}
            </a>
          );
        } else if (record.depositTo) {
          return (
            <a href={`/admin/deposits/${record.depositTo.id}/view`}>
              {record.depositTo.name}
            </a>
          );
        }
        return "-";
      },
    },
    {
      title: t("Common-Vehicle"),
      key: "vehicle",
      render: (record: any) => record.vehicle?.name || "-",
    },
    {
      title: t("Common-Type"),
      dataIndex: "type",
      render: (type: string) => {
        if (!type) return "-";
        switch (type) {
          case "MONTHLY":
            return t("Common-Monthly");
          case "WEEKLY":
            return t("Common-Weekly");
          case "ANUALLY":
            return t("Common-Anually");
          default:
            return type;
        }
      },
    },
    {
      title: t("Common-StartTime"),
      dataIndex: "startTime",
      render: (time: any) => time || "-",
    },
    {
      title: t("Common-EndTime"),
      dataIndex: "endTime",
      render: (time: any) => time || "-",
    },
    {
      title: t("Common-Actions"),
      key: "action",
      render: (record: any) => (
        <Space size="middle">
          <DeleteOutlined
            onClick={() => {
              showDeleteScheduleConfirm(record.id);
            }}
          />
        </Space>
      ),
    },
  ];

  const handleFetchAcceptedPaymentMethods = async () => {
    const response = await getAllAcceptedPaymentMethods();
    setAcceptedPaymentMethods(response);
  };

  const getTypesOptions = () => {
    const options: any[] = [];

    types.forEach(function (item: any) {
      options.push(
        <Select.Option value={item.value} key={item.value}>
          {item.descriptionEs}
        </Select.Option>
      );
    });

    return options;
  };

  const handleCancelButton = () => {
    infoBranchOfficeForm.resetFields();
  };

  const getOptions = (items: any) => {
    const options: any[] = [];

    items.forEach(function (item: any) {
      options.push(
        <Select.Option value={item.id} key={item.id}>
          {item.name}
        </Select.Option>
      );
    });

    return options;
  };

  const getOptionsCategories = (items: any) => {
    const options: any[] = [];

    items?.forEach(function (item: any) {
      const parentsString = item?.parents
        ? item.parents.filter(Boolean).join(" - ")
        : "";
      const categoryName = item?.name || "";

      const categoryTree = parentsString
        ? `${parentsString} - ${categoryName}`
        : categoryName;

      options.push(
        <Select.Option value={item.id} key={item.id}>
          {categoryTree}
        </Select.Option>
      );
    });

    return options;
  };

  const getAcceptedPaymentMethodsOptions = (items: any) => {
    const options: any[] = [];

    items.forEach(function (item: any) {
      if (
        !branchOffice.restrictedAcceptedPaymentMethods.find(
          (paymentMethod: any) => item.id === paymentMethod.id
        )
      )
        options.push(
          <Select.Option value={item.id} key={item.id}>
            {item.name}
          </Select.Option>
        );
    });

    return options;
  };

  const getChannelOptions = (items: any) => {
    const options: any[] = [];

    items.forEach(function (item: any) {
      options.push(
        <Select.Option value={item.id} key={item.id}>
          {`${item.businessUnit.name} - ${item.type.descriptionEs}`}
        </Select.Option>
      );
    });

    return options;
  };

  const showNewSalePointModal = () => {
    setIsNewSalePointModalVisible(true);
  };

  const handleCancelNewSalePointModal = () => {
    setIsNewSalePointModalVisible(false);
  };

  const handleCancelEditSalePointModal = () => {
    setIsEditSalePointModalVisible(false);
    setEditingSalePoint(null);
    editSalePointForm.resetFields();
  };

  const handleEditBranchOffice = async () => {
    setSaving(true);

    const editedBranchOffice = infoBranchOfficeForm.getFieldsValue();
    editedBranchOffice.businessUnitsIds = [businessUnitSelected];
    editedBranchOffice.id = id;
    editedBranchOffice.restrictedArticlesIds = articlesSelected.map(
      (article) => article.id
    );
    editedBranchOffice.belongsShoppingCenter = belongsShoppingCenter;
    const response = await editBranchOffice(editedBranchOffice);

    if (response) {
      message.success(t("Common-EditSuccessMessage"));
      handleFetchBranchOffice();
    } else message.error(t("Common-EditErrorMessage"));
    setSaving(false);
  };

  const handleCreateSalePoint = async (data: any) => {
    setSalePointsLoading(true);
    let response = await createSalePoint(
      parseInt(id!),
      data.name,
      data.acceptedPaymentMethodsIds,
      data.externalId
    );
    if (response) {
      message.success(t("Common-CreateSuccessMessage"));
      newSalePointForm.resetFields();
      handleCancelNewSalePointModal();
      await handleFetchBranchOffice();
    } else message.error(t("Common-ErrorMessage"));

    setSalePointsLoading(false);
  };

  const showDeleteSalePointConfirm = (salePointId: number) => {
    Modal.confirm({
      title: t("Common-DeleteConfirm"),
      icon: <ExclamationCircleOutlined />,
      content: "",
      okText: t("Common-Yes"),
      okType: "danger",
      cancelText: t("Common-No"),
      onOk() {
        handleDeleteSalePoint(salePointId);
      },
    });
  };

  const showImportModal = () => {
    setIsImportModalVisible(true);
    setImportErrors("");
  };

  const excelButtons = (
    <>
      <Button
        onClick={showImportModal}
        className={styles.importButton}
        type="primary"
      >
        {t("Common-Import")}
      </Button>
      <Button
        onClick={() =>
          handleDownloadTemplate("branchOffices/stocks", setDownloadingTemplate)
        }
        loading={downloadingTemplate}
        className={styles.importButton}
        type="primary"
      >
        {t("Common-DownloadTemplate")}
      </Button>
    </>
  );

  const handleCancelImportModal = () => {
    setIsImportModalVisible(false);
  };

  const handleImportFile = async (file: any) => {
    if (file) {
      const response = await processExcelTemplate("branchOffices/stocks", file);
      if (response.success) {
        setImportErrors(null);
        setIsImportModalVisible(false);
        message.success(
          t("Common-ImportSuccess", { quantity: response.data.added })
        );
        handleFetchBranchOfficeSkus();
      } else {
        if (response.data?.errors) setImportErrors(response.data.errors);
        else message.error(t("Error-CommonError"));
      }
    }
  };

  const handleDeleteSalePoint = async (salePointId: number) => {
    setSalePointsLoading(true);
    const deleteStatus = await deleteSalePoint(salePointId);
    if (!deleteStatus) message.error(t("Common-DeleteErrorMessage"));
    else message.success(t("Common-DeleteSuccessMessage"));
    await handleFetchBranchOffice();
    setSalePointsLoading(false);
  };

  const handleSearchCategories = async (value: string) => {
    if (value.length > 2) {
      const response = await getCategoriesFiltered(value);
      setCategories(response);
    } else setCategories([]);
  };

  const handleEditSalePoint = async (values: any) => {
    setSalePointsLoading(true);

    const { id, name, acceptedPaymentMethodsIds, externalId } = values;
    const response = await editSalePoint(
      id,
      name,
      acceptedPaymentMethodsIds,
      externalId
    );

    if (response) {
      message.success(t("Common-EditSuccessMessage"));
      handleCancelEditSalePointModal();
      await handleFetchBranchOffice();
    } else message.error(t("Common-EditErrorMessage"));

    setSalePointsLoading(false);
  };

  const handleAddArticle = (articlesToAdd: any) => {
    const newArticles: any[] = [];
    articlesToAdd.forEach((articleToAdd: any) => {
      if (
        articlesSelected.find(
          (article: any) => article.id === articleToAdd.id
        ) === undefined
      )
        newArticles.push(articleToAdd);
    });
    setArticlesSelected([...articlesSelected, ...newArticles]);
  };

  const handleRemoveArticle = (articleRemove: any) => {
    const articlesWithoutRemoved = articlesSelected.filter(
      (article) => article.id !== articleRemove.id
    );

    setArticlesSelected(articlesWithoutRemoved);
  };

  const handleSearchDeposits = async (value: string) => {
    const response = await getDepositsFiltered(0, {
      name: value,
    });
    setDeposits(response.deposits);
  };

  const showEditSalePointModal = (salePoint: any) => {
    const editedPaymentMethods: number[] = [];
    salePoint.acceptedPaymentMethods.forEach((paymentMethod: any) =>
      editedPaymentMethods.push(paymentMethod.id)
    );

    setEditingSalePoint(salePoint);
    editSalePointForm.setFieldsValue({
      id: salePoint.id,
      name: salePoint.name,
      externalId: salePoint.externalId,
      acceptedPaymentMethodsIds: editedPaymentMethods,
    });
    setIsEditSalePointModalVisible(true);
  };

  const salesPointColumns = [
    {
      title: t("Common-Name"),
      dataIndex: "name",
      key: "name",
    },
    {
      title: t("Common-ExternalId"),
      dataIndex: "externalId",
      key: "externalId",
    },
    {
      title: t("Common-AcceptedPaymentMethods"),
      dataIndex: "acceptedPaymentMethods",
      key: "acceptedPaymentMethods",
      render: (acceptedPaymentMethods: any[]) => (
        <>
          {acceptedPaymentMethods.map((acceptedPaymentMethod) => {
            return (
              <Tag
                className={styles.tag}
                color="blue"
                key={acceptedPaymentMethod.id}
              >
                {acceptedPaymentMethod.name}
              </Tag>
            );
          })}
        </>
      ),
    },
    {
      title: t("Common-Actions"),
      key: "action",
      render: (text: any, record: any) => (
        <Space size="middle">
          {hasPermission(privilegesEnum.WRITE_BUSINESS_UNITS) && (
            <EditOutlined
              onClick={() => {
                showEditSalePointModal(record);
              }}
            />
          )}
          {hasPermission(privilegesEnum.WRITE_BUSINESS_UNITS) && (
            <DeleteOutlined
              onClick={() => {
                showDeleteSalePointConfirm(record.id);
              }}
            />
          )}
        </Space>
      ),
    },
  ];

  const historicalStockColumns = [
    {
      title: t("Common-Sku"),
      dataIndex: "sku",
      render: (sku: any) => sku.name,
    },
    {
      title: t("Common-Date"),
      dataIndex: "date",
      render: (date: string) => date.split("T")[0],
    },
    {
      title: t("Common-Stock"),
      dataIndex: "stock",
    },
  ];

  return loading ? (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <div>
          <Skeleton.Input style={{ width: 180, height: 20 }} active />
        </div>
        <div className={styles.actionButtonsWrapper}>
          <Skeleton.Button style={{ width: 80, height: 32 }} active />
          <Skeleton.Button style={{ width: 80, height: 32 }} active />
        </div>
      </div>

      <div className={styles.tabsContainer}>
        <div
          style={{ padding: "16px 20px", borderBottom: "1px solid #f0f0f0" }}
        >
          <Skeleton.Button
            style={{ width: 60, height: 20, marginRight: 24 }}
            active
          />
          <Skeleton.Button
            style={{ width: 60, height: 20, marginRight: 24 }}
            active
          />
          <Skeleton.Button
            style={{ width: 80, height: 20, marginRight: 24 }}
            active
          />
          <Skeleton.Button
            style={{ width: 50, height: 20, marginRight: 24 }}
            active
          />
          <Skeleton.Button style={{ width: 100, height: 20 }} active />
        </div>
        <div className={styles.branchOfficeInfoWrapper}>
          <Skeleton active paragraph={{ rows: 12 }} />
        </div>
      </div>
    </div>
  ) : !branchOffice ? (
    <NotFound />
  ) : (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <div>
          <CustomBreadcrumb
            items={[
              {
                icon: <LiaStoreSolid />,
                label: t("Common-BranchOffices"),
                path: "/admin/branchoffices"
              },
              {
                label: branchOffice?.name || t("Common-BranchOffice"),
                isCurrentPage: true
              }
            ]}
          />
        </div>
        <ActionButtons
          onSave={handleEditBranchOffice}
          onCancel={handleCancelButton}
          loading={saving}
          disabled={saving}
          show={activeTab === "general"}
          permission={privilegesEnum.WRITE_BUSINESS_UNITS}
        />
      </div>

      <Tabs
        activeKey={activeTab}
        onChange={setActiveTab}
        className={styles.tabsContainer}
      >
        <Tabs.TabPane tab={t("BranchOffice-Tab-General")} key="general">
          <div className={styles.branchOfficeInfoWrapper}>
            <Form
              name="branchOffice"
              initialValues={{ remember: true }}
              autoComplete="off"
              className={styles.newForm}
              layout="vertical"
              form={infoBranchOfficeForm}
            >
              <div className={styles.sectionTitle}>
                {t("Common-BasicInformation")}
              </div>
              <div className={styles.sectionDivider} />
              <div className={styles.itemWrapper}>
                <Form.Item
                  label={t("Common-Code")}
                  name="code"
                  initialValue={branchOffice?.id}
                  className={styles.formItem}
                  rules={[
                    {
                      required: true,
                      message: t("BusinessRules-LanguageNotEntered"),
                    },
                  ]}
                >
                  <Input disabled={true} placeholder={t("Common-Code")} />
                </Form.Item>
                <Form.Item
                  label={t("Common-Name")}
                  name="name"
                  initialValue={branchOffice?.name}
                  className={styles.formItem}
                  rules={[
                    {
                      required: true,
                      message: t("Common-NameNotEntered"),
                    },
                  ]}
                >
                  <Input disabled={!canEdit} placeholder={t("Common-Name")} />
                </Form.Item>

                <Form.Item
                  className={styles.formItem}
                  label={t("Common-ExternalId")}
                  name="externalId"
                  initialValue={branchOffice.externalId}
                >
                  <Input
                    disabled={!canEdit}
                    placeholder={t("Common-ExternalId")}
                  />
                </Form.Item>

                <Form.Item
                  label={t("Common-Type")}
                  name="type"
                  initialValue={branchOffice?.type}
                  className={styles.formItem}
                  rules={[
                    {
                      required: true,
                      message: t("Common-Type"),
                    },
                  ]}
                >
                  <Select
                    className={styles.type}
                    allowClear
                    style={{ width: "100%" }}
                    placeholder=""
                    disabled={!canEdit}
                    onChange={(value) => {
                      if (value === "ECOMMERCE") setIsOnline(true);
                      else setIsOnline(false);
                    }}
                  >
                    {getTypesOptions()}
                  </Select>
                </Form.Item>
                <Form.Item
                  label={t("Common-Channel")}
                  name="channelId"
                  className={styles.formItem}
                  initialValue={branchOffice?.channel?.id}
                >
                  <Select
                    allowClear
                    placeholder={t("Common-Channel")}
                    showSearch
                    optionFilterProp="children"
                    defaultValue={branchOffice?.channel?.id}
                    filterOption={(input: string, option: any) =>
                      (option?.children as string)
                        ?.toLowerCase()
                        .includes(input.toLowerCase())
                    }
                  >
                    {getChannelOptions(channels)}
                  </Select>
                </Form.Item>
              </div>
              {isOnline && (
                <div className={styles.itemWrapper}>
                  <Form.Item
                    label={t("Common-Url")}
                    name="url"
                    initialValue={branchOffice?.url}
                    className={styles.formItem}
                    rules={[
                      {
                        type: "url",
                        message: t("Common-Url"),
                      },
                    ]}
                  >
                    <Input
                      disabled={!canEdit}
                      placeholder={t("Common-exampleURL")}
                    />
                  </Form.Item>
                  <Form.Item
                    label={t("Common-Marketplace")}
                    name="marketplace"
                    initialValue={branchOffice?.marketplace}
                    className={styles.formItem}
                  >
                    <Input
                      disabled={!canEdit}
                      placeholder={t("Common-Marketplace")}
                    />
                  </Form.Item>
                </div>
              )}
              <div className={styles.sectionTitle}>
                {t("Common-PriceAndCosts")}
              </div>
              <div className={styles.sectionDivider} />
              <div className={styles.itemWrapper}>
                <Form.Item
                  label={t("Common-ValuedInventory")}
                  name="valuedInventory"
                  initialValue={branchOffice?.totalCostsByArticle.reduce(
                    (acc: number, item: any) => {
                      return acc + item.cost;
                    },
                    0
                  )}
                  className={styles.formItem}
                >
                  <Input
                    disabled={true}
                    placeholder={t("Common-ValuedInventory")}
                  />
                </Form.Item>
                <Form.Item
                  label={t("Common-PriceRestriction")}
                  name="priceRestriction"
                  initialValue={branchOffice?.priceRestriction}
                  className={styles.formItem}
                >
                  <Input
                    disabled={!canEdit}
                    placeholder={t("Common-PriceRestriction")}
                  />
                </Form.Item>
                <Form.Item
                  label={t("Common-PriceVariation")}
                  name="priceVariation"
                  initialValue={branchOffice?.priceVariation}
                  className={styles.formItem}
                >
                  <Input
                    disabled={!canEdit}
                    placeholder={t("Common-PriceVariation")}
                  />
                </Form.Item>
                <Form.Item
                  className={styles.formItem}
                  label={t("Common-StorageCostPerUnit")}
                  name="storageCostPerUnit"
                  initialValue={branchOffice?.storageCostPerUnit}
                >
                  <InputNumber
                    disabled={!canEdit}
                    placeholder={t("Common-StorageCostPerUnit")}
                    className={styles.inputNumber}
                  />
                </Form.Item>
              </div>

              <div className={styles.sectionTitle}>
                {t("Common-AddressSection")}
              </div>
              <div className={styles.sectionDivider} />
              <div className={styles.itemWrapper}>
                <Form.Item
                  label={t("Common-Address")}
                  name="address"
                  initialValue={branchOffice?.address}
                  className={styles.formItem}
                >
                  <Input placeholder={t("Common-Address")} />
                </Form.Item>
              </div>
              <div className={styles.itemWrapper}>
                <Form.Item
                  label={t("Common-Latitude")}
                  name="latitude"
                  initialValue={branchOffice?.latitude}
                  className={styles.formItem}
                >
                  <InputNumber
                    className={styles.inputNumber}
                    placeholder={t("Common-Latitude")}
                  />
                </Form.Item>
                <Form.Item
                  label={t("Common-Longitude")}
                  name="longitude"
                  initialValue={branchOffice?.longitude}
                  className={styles.formItem}
                >
                  <InputNumber
                    className={styles.inputNumber}
                    placeholder={t("Common-Longitude")}
                  />
                </Form.Item>
              </div>

              <div className={styles.sectionTitle}>{t("Common-Stock")}</div>
              <div className={styles.sectionDivider} />
              <div className={styles.itemWrapper}>
                <Form.Item
                  label={t("Common-MinimumStock")}
                  name="minimumStock"
                  className={styles.formItem}
                  initialValue={branchOffice?.minimumStock}
                >
                  <InputNumber
                    disabled={!canEdit}
                    placeholder={t("Common-MinimumStock")}
                    className={styles.inputNumber}
                  />
                </Form.Item>
                <Form.Item
                  label={t("Common-MaximumStock")}
                  name="maximumStock"
                  className={styles.formItem}
                  initialValue={branchOffice?.maximumStock}
                >
                  <InputNumber
                    disabled={!canEdit}
                    placeholder={t("Common-MaximumStock")}
                    className={styles.inputNumber}
                  />
                </Form.Item>
              </div>
              <div className={styles.itemWrapperException}>
                <Form.Item
                  label={t("Common-RoomSpace")}
                  name="roomCapacity"
                  initialValue={branchOffice?.roomCapacity}
                  className={styles.formItem}
                >
                  <InputNumber
                    disabled={!canEdit}
                    placeholder={t("Common-RoomSpace")}
                    addonAfter={t("Common-Units")}
                    className={styles.inputNumber}
                  />
                </Form.Item>
              </div>
              <div className={styles.sectionTitle}>
                {t("Common-ChannelAndRestrictions")}
              </div>
              <div className={styles.sectionDivider} />
              <div className={styles.itemWrapper}>
                <Form.Item
                  label={t("Common-RestrictedCategories")}
                  name="restrictedCategoriesIds"
                  className={styles.formItem}
                  initialValue={branchOffice?.restrictedCategories.map(
                    (categorie: any) => categorie.id
                  )}
                >
                  <Select
                    className={styles.multipleSelect}
                    mode="multiple"
                    allowClear
                    style={{ width: "100%" }}
                    onSearch={handleSearchCategories}
                    placeholder={t("Common-SearchByName")}
                    defaultValue={branchOffice?.restrictedCategories.map(
                      (categorie: any) => categorie.id
                    )}
                    filterOption={(input: string, option: any) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    {getOptionsCategories(categories)}
                  </Select>
                </Form.Item>
                <Form.Item
                  label={t("Common-BelongsShoppingCenter")}
                  name="belongsShoppingCenter"
                  initialValue={belongsShoppingCenter}
                  className={styles.formItem}
                  rules={[
                    {
                      required: true,
                      message: t("Common-BelongsShoppingCenter"),
                    },
                  ]}
                >
                  <Switch
                    defaultChecked={belongsShoppingCenter}
                    disabled={!canEdit}
                    onChange={setBelongsShoppingCenter}
                  />
                </Form.Item>
                {belongsShoppingCenter && (
                  <Form.Item
                    label={t("Common-ShoppingCenter")}
                    name="shoppingCenter"
                    initialValue={branchOffice?.shoppingCenter}
                    className={styles.formItem}
                  >
                    <Input
                      disabled={!canEdit}
                      placeholder={t("Common-ShoppingCenter")}
                    />
                  </Form.Item>
                )}
              </div>
              <div className={styles.itemWrapper}>
                <Form.Item
                  label={t("Common-RestrictedPaymentMethods")}
                  initialValue={branchOffice?.restrictedAcceptedPaymentMethods.map(
                    (acceptedPaymentMethod: any) => acceptedPaymentMethod.id
                  )}
                  name="restrictedAcceptedPaymentMethodsIds"
                  className={styles.formItem}
                >
                  <Select
                    className={styles.multipleSelect}
                    mode="multiple"
                    allowClear
                    style={{ width: "100%" }}
                    placeholder=""
                    defaultValue={branchOffice?.restrictedAcceptedPaymentMethods.map(
                      (acceptedPaymentMethod: any) => acceptedPaymentMethod.id
                    )}
                    filterOption={(input: string, option: any) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    {getOptions(acceptedPaymentMethods)}
                  </Select>
                </Form.Item>
                <Form.Item
                  label={t("Common-OwnInventory")}
                  name="ownInventory"
                  initialValue={ownInventory}
                  className={styles.formItem}
                  rules={[
                    {
                      required: true,
                      message: t("Common-OwnInventory"),
                    },
                  ]}
                >
                  <Switch
                    defaultChecked={ownInventory}
                    disabled={!canEdit}
                    onChange={setOwnInventory}
                  />
                </Form.Item>
                {ownInventory && (
                  <Form.Item
                    label={t("Common-Deposit")}
                    name="depositId"
                    initialValue={branchOffice?.supplyDeposit.id}
                    className={styles.formItem}
                  >
                    <Select
                      allowClear
                      showSearch
                      onSearch={handleSearchDeposits}
                      placeholder={t("Common-SearchByName")}
                      filterOption={(input: string, option: any) =>
                        option.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                    >
                      {getOptions(deposits)}
                    </Select>
                  </Form.Item>
                )}
              </div>
              <AddArticleModal
                title={t("Common-RestrictedArticles")}
                selectedArticles={articlesSelected}
                onAddArticle={handleAddArticle}
                onRemoveArticle={handleRemoveArticle}
              />
            </Form>
          </div>
        </Tabs.TabPane>

        <Tabs.TabPane tab={t("BranchOffice-Tab-Schedules")} key="schedules">
          <div className={styles.tableWrapper}>
            <div className={styles.tablesHeader}>
              <h1 className={styles.tableTitle}>{t("Common-Schedules")}</h1>
              {canEdit && (
                <Button
                  type="primary"
                  className={styles.actionsButton}
                  onClick={handleOpenAddScheduleModal}
                  icon={<PlusOutlined />}
                />
              )}
            </div>
            <div>
              {branchOffice?.schedules && branchOffice.schedules.length > 0 ? (
                <Table
                  size="small"
                  className={styles.table}
                  loading={loading}
                  rowKey={(record) => record.id}
                  columns={schedulesColumns}
                  dataSource={branchOffice.schedules}
                />
              ) : (
                <div className={styles.emptyState}>
                  <Empty
                    description={
                      <div>
                        <div className={styles.emptyTitle}>
                          {t("BranchOffice-EmptySchedules")}
                        </div>
                        <div className={styles.emptyDescription}>
                          {t("BranchOffice-EmptySchedulesDescription")}
                        </div>
                      </div>
                    }
                  >
                    {canEdit && (
                      <Button
                        type="primary"
                        icon={<PlusOutlined />}
                        onClick={handleOpenAddScheduleModal}
                        className={styles.emptyButton}
                      >
                        {t("BranchOffice-AddFirstSchedule")}
                      </Button>
                    )}
                  </Empty>
                </div>
              )}
            </div>
          </div>
        </Tabs.TabPane>

        <Tabs.TabPane tab={t("BranchOffice-Tab-SalesPoints")} key="salespoints">
          <div className={styles.tableWrapper}>
            <div className={styles.tablesHeader}>
              <h1 className={styles.tableTitle}>{t("Common-SalesPoints")}</h1>
              {canEdit && (
                <Button
                  type="primary"
                  className={styles.actionsButton}
                  onClick={() => showNewSalePointModal()}
                  icon={<PlusOutlined />}
                />
              )}
            </div>
            <div>
              {branchOffice.salePoints && branchOffice.salePoints.length > 0 ? (
                <Table
                  size="small"
                  className={styles.table}
                  loading={salePointsLoading}
                  rowKey={(record) => record.id}
                  columns={salesPointColumns}
                  dataSource={branchOffice.salePoints}
                />
              ) : (
                <div className={styles.emptyState}>
                  <Empty
                    description={
                      <div>
                        <div className={styles.emptyTitle}>
                          {t("BranchOffice-EmptySalesPoints")}
                        </div>
                        <div className={styles.emptyDescription}>
                          {t("BranchOffice-EmptySalesPointsDescription")}
                        </div>
                      </div>
                    }
                  >
                    {canEdit && (
                      <Button
                        type="primary"
                        icon={<PlusOutlined />}
                        onClick={() => showNewSalePointModal()}
                        className={styles.emptyButton}
                      >
                        {t("BranchOffice-AddFirstSalesPoint")}
                      </Button>
                    )}
                  </Empty>
                </div>
              )}
            </div>
          </div>
        </Tabs.TabPane>

        <Tabs.TabPane tab={t("BranchOffice-Tab-Stock")} key="stock">
          <ArticleStock
            data={skus}
            header={excelButtons}
            fetchData={handleFetchBranchOfficeSkus}
            type={"branchOffices"}
            placeId={parseInt(id!)}
            totalElements={totalSizeSkus}
            updatePage={setSkusActualPage}
            searchByName={true}
            updateName={setSkuFilterValue}
            page={skusActualPage}
            loadingPage={loadingSkus}
          />
        </Tabs.TabPane>

        <Tabs.TabPane
          tab={t("BranchOffice-Tab-HistoricalStock")}
          key="historicalstock"
        >
          <div className={styles.tableWrapper}>
            <div className={styles.tablesHeader}>
              <h1 className={styles.tableTitle}>
                {t("Common-HistoricalStock")}
              </h1>
            </div>
            <div className={styles.filtersWrapper}>
              <div className={styles.filterWrapper}>
                <DatePicker.RangePicker
                  className={styles.dateSelector}
                  placeholder={[t("Common-Start"), t("Common-End")]}
                  onChange={(dates) => setSelectedDates(dates)}
                ></DatePicker.RangePicker>
              </div>
            </div>
            <div>
              {loadingHistoricalStock ||
              (historicalStocks && historicalStocks.length > 0) ? (
                <Table
                  size="small"
                  className={styles.table}
                  loading={loadingHistoricalStock}
                  rowKey={(record) => record.id}
                  columns={historicalStockColumns}
                  pagination={{
                    total: totalSizeHistoricalStock,
                    showSizeChanger: false,
                    onChange: handleFetchHistoricalStock,
                    current: historicalStockActualPage,
                  }}
                  dataSource={historicalStocks}
                />
              ) : (
                <div className={styles.emptyState}>
                  <Empty
                    description={
                      <div>
                        <div className={styles.emptyTitle}>
                          {t("BranchOffice-EmptyHistoricalStock")}
                        </div>
                        <div className={styles.emptyDescription}>
                          {t("BranchOffice-EmptyHistoricalStockDescription")}
                        </div>
                      </div>
                    }
                  />
                </div>
              )}
            </div>
          </div>
        </Tabs.TabPane>
      </Tabs>

      {/* Modals section */}
      <div>
        {hasPermission(privilegesEnum.WRITE_BRANCH_OFFICES) && (
          <Modal
            title={t("Common-NewSalePoint")}
            visible={isNewSalePointModalVisible}
            okButtonProps={{ style: { display: "none" } }}
            cancelButtonProps={{ style: { display: "none" } }}
            onCancel={handleCancelNewSalePointModal}
            className={styles.salePointModal}
            width={500}
          >
            <Form
              name="basic"
              initialValues={{ remember: true }}
              autoComplete="off"
              layout="vertical"
              form={newSalePointForm}
              onFinish={handleCreateSalePoint}
              className={styles.salePointForm}
            >
              <Form.Item
                label={
                  <span>
                    {t("Common-Name")}{" "}
                    <span className={styles.requiredMark}>*</span>
                  </span>
                }
                name="name"
                rules={[
                  {
                    required: true,
                    message: t("Common-NameNotEntered"),
                  },
                ]}
              >
                <Input
                  placeholder={t("Common-Name")}
                  className={styles.modalInput}
                />
              </Form.Item>

              <Form.Item label={t("Common-ExternalId")} name="externalId">
                <Input
                  placeholder={t("Common-ExternalId")}
                  className={styles.modalInput}
                />
              </Form.Item>

              <Form.Item
                label={
                  <span>
                    {t("Common-AcceptedPaymentMethods")}{" "}
                    <span className={styles.requiredMark}>*</span>
                  </span>
                }
                name="acceptedPaymentMethodsIds"
                rules={[
                  {
                    required: true,
                    message: t("Common-AcceptedPaymentMethods"),
                  },
                ]}
              >
                <Select
                  allowClear
                  mode="multiple"
                  style={{ width: "100%" }}
                  placeholder={t("Common-AcceptedPaymentMethods")}
                  className={styles.modalSelect}
                  filterOption={(input: string, option: any) => {
                    const children = option?.children as any;
                    if (typeof children === "string") {
                      return (
                        children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                      );
                    }
                    if (Array.isArray(children)) {
                      return (
                        children
                          .join("")
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      );
                    }
                    return (
                      String(children || "")
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    );
                  }}
                >
                  {getAcceptedPaymentMethodsOptions(acceptedPaymentMethods)}
                </Select>
              </Form.Item>
              <div className={styles.modalButtons}>
                <Button
                  type="default"
                  onClick={handleCancelNewSalePointModal}
                  className={styles.modalCancelButton}
                >
                  {t("Common-Cancel")}
                </Button>
                <Button
                  type="primary"
                  htmlType="submit"
                  loading={salePointsLoading}
                  className={styles.modalSubmitButton}
                >
                  {t("Common-Add")}
                </Button>
              </div>
            </Form>
          </Modal>
        )}
        {hasPermission(privilegesEnum.WRITE_BRANCH_OFFICES) && (
          <Modal
            title={t("Common-EditSalePoint", {
              name: editingSalePoint?.name || "",
            })}
            visible={isEditSalePointModalVisible}
            okButtonProps={{ style: { display: "none" } }}
            cancelButtonProps={{ style: { display: "none" } }}
            onCancel={handleCancelEditSalePointModal}
            className={styles.salePointModal}
            width={500}
          >
            <Form
              name="editSalePoint"
              initialValues={{ remember: true }}
              autoComplete="off"
              layout="vertical"
              form={editSalePointForm}
              onFinish={handleEditSalePoint}
              className={styles.salePointForm}
            >
              <Form.Item name="id" style={{ display: "none" }}>
                <Input type="hidden" />
              </Form.Item>

              <Form.Item
                label={
                  <span>
                    {t("Common-Name")}{" "}
                    <span className={styles.requiredMark}>*</span>
                  </span>
                }
                name="name"
                rules={[
                  {
                    required: true,
                    message: t("Common-NameNotEntered"),
                  },
                ]}
              >
                <Input
                  placeholder={t("Common-Name")}
                  className={styles.modalInput}
                />
              </Form.Item>

              <Form.Item label={t("Common-ExternalId")} name="externalId">
                <Input
                  placeholder={t("Common-ExternalId")}
                  className={styles.modalInput}
                />
              </Form.Item>

              <Form.Item
                label={
                  <span>
                    {t("Common-AcceptedPaymentMethods")}{" "}
                    <span className={styles.requiredMark}>*</span>
                  </span>
                }
                name="acceptedPaymentMethodsIds"
                rules={[
                  {
                    required: true,
                    message: t("Common-AcceptedPaymentMethods"),
                  },
                ]}
              >
                <Select
                  allowClear
                  mode="multiple"
                  style={{ width: "100%" }}
                  placeholder={t("Common-AcceptedPaymentMethods")}
                  className={styles.modalSelect}
                  filterOption={(input: string, option: any) => {
                    const children = option?.children as any;
                    if (typeof children === "string") {
                      return (
                        children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                      );
                    }
                    if (Array.isArray(children)) {
                      return (
                        children
                          .join("")
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      );
                    }
                    return (
                      String(children || "")
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    );
                  }}
                >
                  {getAcceptedPaymentMethodsOptions(acceptedPaymentMethods)}
                </Select>
              </Form.Item>

              <div className={styles.modalButtons}>
                <Button
                  type="default"
                  onClick={handleCancelEditSalePointModal}
                  className={styles.modalCancelButton}
                >
                  {t("Common-Cancel")}
                </Button>
                <Button
                  type="primary"
                  htmlType="submit"
                  loading={salePointsLoading}
                  className={styles.modalSubmitButton}
                >
                  {t("Common-Save")}
                </Button>
              </div>
            </Form>
          </Modal>
        )}
        <Modal
          title={t("Common-ImportEntity", {
            entity: t("Common-Stock"),
          })}
          visible={isImportModalVisible}
          okButtonProps={{ style: { display: "none" } }}
          cancelButtonProps={{ style: { display: "none" } }}
          onCancel={handleCancelImportModal}
        >
          <ImportModal onOk={handleImportFile} errors={importErrors} />
        </Modal>

        {/* Add Schedule Modal */}
        <Modal
          title={t("Common-Transfer")}
          visible={isAddScheduleModalVisible}
          onCancel={handleCancelAddScheduleModal}
          footer={null}
        >
          <Form
            form={addScheduleForm}
            onFinish={handleAddSchedule}
            layout="vertical"
          >
            <Form.Item
              name="code"
              label={t("Common-Code")}
              rules={[
                {
                  required: true,
                  message: t("Common-CodeNotEntered"),
                },
              ]}
            >
              <InputNumber
                style={{ width: "100%" }}
                placeholder={t("Common-Code")}
              />
            </Form.Item>

            <Form.Item
              name="description"
              label={t("Common-Description")}
              rules={[
                {
                  required: true,
                  message: t("Common-DescriptionNotEntered"),
                },
              ]}
            >
              <Input placeholder={t("Common-Description")} />
            </Form.Item>

            <Form.Item
              name="destinationType"
              label={t("Common-DestinationType")}
              initialValue="branchOffice"
            >
              <Radio.Group
                onChange={(e) => {
                  setDestinationType(e.target.value);
                  addScheduleForm.setFieldsValue({
                    branchOfficeIdTo: undefined,
                    depositIdTo: undefined,
                  });
                }}
              >
                <Radio value="branchOffice">{t("Common-BranchOffice")}</Radio>
                <Radio value="deposit">{t("Common-Deposit")}</Radio>
              </Radio.Group>
            </Form.Item>

            {destinationType === "branchOffice" && (
              <Form.Item
                name="branchOfficeIdTo"
                label={t("Common-DestinationBranchOffice")}
                rules={[
                  {
                    required: true,
                    message: t("Common-DestinationBranchOfficeNotSelected"),
                  },
                ]}
              >
                <Select
                  allowClear
                  placeholder={t("Common-SelectDestinationBranchOffice")}
                  showSearch
                  onSearch={handleSearchBranchOfficesFast}
                  filterOption={false}
                >
                  {getOptions(allBranchOffices)}
                </Select>
              </Form.Item>
            )}

            {destinationType === "deposit" && (
              <Form.Item
                name="depositIdTo"
                label={t("Common-DestinationDeposit")}
                rules={[
                  {
                    required: true,
                    message: t("Common-DestinationDepositNotSelected"),
                  },
                ]}
              >
                <Select
                  allowClear
                  placeholder={t("Common-SelectDestinationDeposit")}
                  showSearch
                  onSearch={handleSearchDepositsForSchedule}
                  filterOption={false}
                >
                  {getOptions(allDeposits)}
                </Select>
              </Form.Item>
            )}

            <Form.Item
              name="vehicleId"
              label={t("Common-Vehicle")}
              rules={[
                {
                  required: true,
                  message: t("Common-VehicleNotSelected"),
                },
              ]}
            >
              <Select
                placeholder={t("Common-SelectVehicle")}
                showSearch
                filterOption={(input, option) => {
                  const children = option?.children as any;
                  if (typeof children === "string") {
                    return (
                      children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    );
                  }
                  if (Array.isArray(children)) {
                    return (
                      children
                        .join("")
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    );
                  }
                  return (
                    String(children || "")
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  );
                }}
              >
                {getOptions(vehicles)}
              </Select>
            </Form.Item>

            <Form.Item
              name="recurrenceType"
              label={t("Common-Recurrence")}
              rules={[
                {
                  required: true,
                  message: t("Common-RecurrenceNotSelected"),
                },
              ]}
            >
              <Select
                placeholder={t("Common-SelectRecurrence")}
                onChange={(value) => {
                  addScheduleForm.setFieldsValue({
                    monday: false,
                    tuesday: false,
                    wednesday: false,
                    thursday: false,
                    friday: false,
                    saturday: false,
                    sunday: false,
                    dayMonthly: undefined,
                    dayAnually: undefined,
                  });
                }}
              >
                {getRecurrenceOptions()}
              </Select>
            </Form.Item>

            {/* Weekly recurrence fields */}
            <Form.Item
              noStyle
              shouldUpdate={(prevValues, currentValues) =>
                prevValues.recurrenceType !== currentValues.recurrenceType
              }
            >
              {({ getFieldValue }) => {
                const recurrenceType = getFieldValue("recurrenceType");
                if (recurrenceType === "WEEKLY") {
                  return (
                    <div
                      style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}
                    >
                      <Form.Item
                        name="monday"
                        valuePropName="checked"
                        style={{ marginBottom: "8px" }}
                      >
                        <Checkbox>{t("Common-Monday")}</Checkbox>
                      </Form.Item>
                      <Form.Item
                        name="tuesday"
                        valuePropName="checked"
                        style={{ marginBottom: "8px" }}
                      >
                        <Checkbox>{t("Common-Tuesday")}</Checkbox>
                      </Form.Item>
                      <Form.Item
                        name="wednesday"
                        valuePropName="checked"
                        style={{ marginBottom: "8px" }}
                      >
                        <Checkbox>{t("Common-Wednesday")}</Checkbox>
                      </Form.Item>
                      <Form.Item
                        name="thursday"
                        valuePropName="checked"
                        style={{ marginBottom: "8px" }}
                      >
                        <Checkbox>{t("Common-Thursday")}</Checkbox>
                      </Form.Item>
                      <Form.Item
                        name="friday"
                        valuePropName="checked"
                        style={{ marginBottom: "8px" }}
                      >
                        <Checkbox>{t("Common-Friday")}</Checkbox>
                      </Form.Item>
                      <Form.Item
                        name="saturday"
                        valuePropName="checked"
                        style={{ marginBottom: "8px" }}
                      >
                        <Checkbox>{t("Common-Saturday")}</Checkbox>
                      </Form.Item>
                      <Form.Item
                        name="sunday"
                        valuePropName="checked"
                        style={{ marginBottom: "8px" }}
                      >
                        <Checkbox>{t("Common-Sunday")}</Checkbox>
                      </Form.Item>
                    </div>
                  );
                }
                return null;
              }}
            </Form.Item>

            {/* Monthly recurrence field */}
            <Form.Item
              noStyle
              shouldUpdate={(prevValues, currentValues) =>
                prevValues.recurrenceType !== currentValues.recurrenceType
              }
            >
              {({ getFieldValue }) => {
                const recurrenceType = getFieldValue("recurrenceType");
                if (recurrenceType === "MONTHLY") {
                  return (
                    <Form.Item
                      name="dayMonthly"
                      label={t("Common-DayOfMonth")}
                      rules={[
                        {
                          required: true,
                          message: t("Common-DayOfMonthNotEntered"),
                        },
                      ]}
                    >
                      <InputNumber
                        min={1}
                        max={31}
                        style={{ width: "100%" }}
                        placeholder={t("Common-DayOfMonth")}
                      />
                    </Form.Item>
                  );
                }
                return null;
              }}
            </Form.Item>

            {/* Annually recurrence field */}
            <Form.Item
              noStyle
              shouldUpdate={(prevValues, currentValues) =>
                prevValues.recurrenceType !== currentValues.recurrenceType
              }
            >
              {({ getFieldValue }) => {
                const recurrenceType = getFieldValue("recurrenceType");
                if (recurrenceType === "ANUALLY") {
                  return (
                    <Form.Item
                      name="dayAnually"
                      label={t("Common-DayOfYear")}
                      rules={[
                        {
                          required: true,
                          message: t("Common-DayOfYearNotEntered"),
                        },
                      ]}
                    >
                      <DatePicker
                        style={{ width: "100%" }}
                        placeholder={t("Common-DayOfYear")}
                      />
                    </Form.Item>
                  );
                }
                return null;
              }}
            </Form.Item>

            {/* Time field */}
            <Form.Item name="startTime" label={t("Common-Time")}>
              <TimePicker.RangePicker
                style={{ width: "100%" }}
                placeholder={["Hora inicio", "Hora fin"]}
                format="HH:mm"
              />
            </Form.Item>

            <Form.Item>
              <Space>
                <Button type="primary" htmlType="submit" loading={loading}>
                  {t("Common-Add")}
                </Button>
                <Button onClick={handleCancelAddScheduleModal}>
                  {t("Common-Cancel")}
                </Button>
              </Space>
            </Form.Item>
          </Form>
        </Modal>
      </div>
    </div>
  );
};

export default ViewBranchOffice;
